import * as OUTPUT_TYPES from './rundown-output.const.ts'
import { RundownOutputLayoutList } from './RundownOutputLayoutList.js'
import { RundownOutputLayoutPrompter } from './RundownOutputLayoutPrompter.tsx'
import { RundownOutputLayoutSingle } from './RundownOutputLayoutSingle.tsx'
import { useRundownOutputOptions } from './useRundownOutputOptions.ts'

export function RundownOutputBody({
  controlsVisible,
}: {
  controlsVisible: boolean
}) {
  const { getOption } = useRundownOutputOptions()

  const layout = getOption(OUTPUT_TYPES.LAYOUT)

  switch (layout) {
    case OUTPUT_TYPES.SINGLE:
      return <RundownOutputLayoutSingle />

    case OUTPUT_TYPES.PROMPTER:
      return <RundownOutputLayoutPrompter controlsVisible={controlsVisible} />

    case OUTPUT_TYPES.LIST:
      return <RundownOutputLayoutList />

    default:
      return <RundownOutputLayoutList />
  }
}
